import { toUpper } from "lodash";
import React, { useContext, useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import cuentaIcon from "../../assets/pepper-icons/sidebar/03_Icono Foto Perfil.svg";
import agregarEmp from "../../assets/pepper-icons/sidebar/16_Icono_Agregar empresa.svg";
import cerrarSesionIcon from "../../assets/pepper-icons/sidebar/17_Icono_Cerrar_sesion.svg";
import { SortCompany } from "../../utils/companyList";
import { startLogout } from "../../redux/actions/auth";
import {
  importSelectedCompany,
  importLoadingState,
} from "../../redux/actions/companyList";

import "./CompanyList.scss";
import { CompanyContext } from "src/context";

export default function CompanyList(props) {
  const dispatch = useDispatch();
  const logout = () => {
    dispatch(startLogout());
  };
  const { showCompanyList, setShowCompanyList, hideCompanyList } = props;
  const [filterCompany, setFilterCompany] = useState();
  let listToShow

  const { companyList, selectedCompany } = useContext(CompanyContext)

  const input = document.querySelector("input");

  if (companyList.length > 0 && !filterCompany) {
    listToShow = companyList?.map((comp) => {
      return (
        <li
          key={comp.id}
          name={comp.name}
          plan={comp.plan}
          className="listContainer__list__body"
          onClick={() => {
            setShowCompanyList(false);
            setFilterCompany("");
          }}
        >
          <img
            style={{ height: "24px", width: "24px", cursor: "pointer" }}
            src={cuentaIcon}
            alt="logo"
            className="listContainer__list__body__img"
          />
          {toUpper(comp.name)}
        </li>
      );
    });
  } else {
    if (companyList.length > 0 && filterCompany) {
      listToShow = companyList?.map((comp) => {
        if (toUpper(comp.name).includes(toUpper(filterCompany))) {
          return (
            <li
              key={comp.id}
              name={comp.name}
              plan={comp.plan}
              className="listContainer__list__body"
              onClick={() => {
                setShowCompanyList(false);
                setFilterCompany("");
              }}
            >
              <img
                style={{ height: "24px", width: "24px", cursor: "pointer" }}
                src={cuentaIcon}
                alt="logo"
                className="listContainer__list__body__img"
              />
              {toUpper(comp.name)}
            </li>
          );
        }
      });
    }
  }

  return (
    <div
      className={
        hideCompanyList
          ? "hideCompanyFromList"
          : showCompanyList
          ? "listContainer"
          : "hideListContainer"
      }
    >
      <button
        onClick={() => {
          setShowCompanyList(false);
          setFilterCompany("");
        }}
        type="button"
        className="listContainer__close"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <div className="listContainer__header">
        <img
          src={cuentaIcon}
          alt="logo"
          className="listContainer__header__image"
        />
        <br />
        {toUpper(selectedCompany.name)}
      </div>
      <div className="listContainer__header__filter">
        {showCompanyList ? (
          <input
            autoFocus
            placeholder="Buscar..."
            value={filterCompany}
            onChange={(e) => setFilterCompany(e.target.value)}
            onKeyUp={(e) => {
              if (e.code === "Escape") {
                setShowCompanyList(false);
              }
            }}
            onKeyPress={(e) => {
              if (e.code === "Enter") {
                let firstCompany = [];
                listToShow.map((element) => {
                  if (element) {
                    if (firstCompany.length < 1) {
                      firstCompany.push({
                        id: element.key,
                        name: element.props.name,
                        plan: element.props.plan,
                        users: element.props.users
                      });
                    }
                    if (firstCompany.length > 0) {
                      setShowCompanyList(false);
                      setFilterCompany("");
                    }
                  }
                });
              }
            }}
            className="listContainer__header__filter__input"
          />
        ) : (
          <div></div>
        )}
      </div>
      <hr />
      <ul className="listContainer__list">{listToShow}</ul>
      <div className="listContainer__addCompany">
        <img
          src={agregarEmp}
          style={{
            height: "20px",
            width: "20px",
            marginRight: "5px",
            verticalAlign: "text-top",
          }}
          alt="logo"
          className="listContainer__header__image"
        />
        Agregar Empresa
      </div>
      <hr />
      <div className="listContainer__logout" onClick={logout}>
        <img
          src={cerrarSesionIcon}
          style={{
            height: "20px",
            width: "20px",
            marginRight: "5px",
            verticalAlign: "text-top",
          }}
          alt="logo"
          className="listContainer__header__image"
        />
        Cerrar Sesión
      </div>
    </div>
  );
}
